<form class="form-vertical" [formGroup]="companyForm">
  <div class="form-row row">
    <div class="form-group">
      <label for="name" class="control-label required">{{'i18n.shared.fields.name' |
        translate}}</label>
      <input type="text" class="e-textbox" id="name" class="form-control" formControlName="name" name='name'>
      <app-error-messages [control]="formFields?.name" [showUntouchedErrors]="!isAdd"></app-error-messages>
    </div>
  </div>
  <div class="form-row row" *ngIf="!isAdd">
    <div class="form-group">
      <label for="active" class="control-label d-block">
        {{'i18n.shared.fields.active' | translate}}
      </label>
      <app-yes-no-group-button id="active" formControlName="active" name='active'></app-yes-no-group-button>
    </div>
  </div>
</form>
